import { z } from "zod";

import http from "@/services/http";

export const entitlementsResponse = z
  .object({
    content_bundle_id: z.number(),
    content_bundle_name: z.string(),
    entitlement_id: z.number(),
  })
  .loose();

const BundlesResponse = z
  .object({
    user_id: z.number(),
    entitlements: z.array(entitlementsResponse),
  })
  .loose();

export const userStatus = z
  .object({
    bundles: BundlesResponse,
    cco_id: z.string(),
    display_name: z.string(),
    loginCount: z.number(),
    surveyCompleted: z.boolean(),
    userId: z.number(),
    userInitials: z.string(),
    "user-roles": z.array(z.any()),
    userEntitlements: z.array(z.string()).nullish().optional(),
    email: z.string(),
    genAIConsent: z.boolean().nullish(),
    dnmAIConsent: z.boolean().nullish(),
  })
  .loose();

export async function fetchUserStatus() {
  if (!globalThis.env.API_PROFILE) {
    return;
  }
  const { data } = await http().get(`${globalThis.env.API_PROFILE}/userStatus`);

  return userStatus.parse(data);
}
